/* eslint-disable eqeqeq, no-unused-vars */
import React from "react";
import AdminHeader from "../../_components/AdminHeader/AdminHeader";
import AdminSidebar from "../../_components/AdminSidebar/AdminSidebar";
import "../UserManagement/UserManagement.css";
import userService from "../../_services/user.service";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import NoDataText from "../../_components/NoDataText/NoDataText";
import ConfirmationAlert from "../../_components/ConfirmationAlert/ConfirmationAlert";
import authenticationService from "../../_services/authentication.service";
import UpdateProfile from "../../_components/UpdateProfile";

class UserManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      isModelOpen: false,
      isSubmitted: false,
      isFormValid: false,
      errors: {},
      confirmPassword: "",
      PkUserId: 0,
      showUpdateProfile: false,
      updateUser: {
        id: 0,
        firstName: "",
        lastName: "",
        contact: "",
        createdBy: authenticationService?.currentUserValue?.id,
        enabled: true,
      },
      user: {
        emailId: "",
        password: "",
        firstName: "",
        lastName: "",
        contact: "",
        createdBy: authenticationService?.currentUserValue?.id,
        enabled: true,
      },
      result: {
        data: [],
        isSuccess: false,
        message: "",
        statusCodeResult: 0,
        errors: null,
        forms: null,
      },
      alertMember: {
        show: true,
        isAnimate: false,
        ariaLabelledby: "",
        title: "",
        message: "",
        buttons: [],
      },
    };
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleResetForm = this.handleResetForm.bind(this);
    this.getData = this.getData.bind(this);
  }
  componentDidMount() {
    this.getData();
  }
  getData() {
    userService
      .getAll()
      .then((data) => this.setState({ result: data }))
      .catch((error) => console.log("Error :" + error));
  }
  handleModelEdit(cell, row, rowIndex) {
    const list = this.state?.result?.data?.filter((u) => u?.id == cell);
    if (list.length > 0) {
      let updateUser = {
        id: list[0]?.id,
        firstName: list[0]?.firstName,
        lastName: list[0]?.lastName,
        contact: list[0]?.contact,
        createdBy: authenticationService?.currentUserValue?.id,
        enabled: list[0]?.enabled,
      };
      this.setState({ showUpdateProfile: true, updateUser: updateUser });
    }
  }
  handleModelDelete(cell, row, rowIndex) {
    let alertMember = {
      show: true,
      isAnimate: false,
      ariaLabelledby: "",
      title: "Confirmation",
      message: "Are you sure want to delete ?",
      buttons: [
        {
          label: "Yes",
          onClick: this.handleYes,
          cssclass: "btn btn-primary btn-sm ts-buttom",
        },
        {
          label: "No",
          onClick: this.handleNo,
          cssclass: "btn btn-danger btn-sm ml-2 ts-buttom",
        },
      ],
    };
    this.setState({
      isModelOpen: true,
      alertMember: alertMember,
      PkUserId: cell,
    });
  }
  updateClose = (isUpdated) => {
    if (isUpdated) {
      this.getData();
    }
    let updateUser = {
      id: 0,
      firstName: "",
      lastName: "",
      contact: "",
      createdBy: 0,
      enabled: false,
    };
    this.setState({ showUpdateProfile: false, updateUser: updateUser });
  };

  handleYes = (e) => {
    e.preventDefault();
    const { PkUserId } = this.state;
    const model = {
      id: PkUserId,
    };
    let formData = JSON.stringify(model);
    userService
      .delete(formData)
      .then((data) => this.responseShow(data))
      .catch((error) => console.log("Error :" + error));
  };

  handleNo = (e) => {
    this.setState({ isModelOpen: false, alertMember: {} });
  };

  GetActionFormat = (cell, row, rowIndex) => {
    return (
      <div>
        <button
          type="button"
          className="btn btn-outline-primary btn-sm ts-buttom"
          size="sm"
          onClick={() => this.handleModelEdit(cell, row, rowIndex)}
        >
          <i className="fa fa-edit"></i>
        </button>
        <button
          type="button"
          className="btn btn-outline-danger btn-sm ml-2 ts-buttom"
          size="sm"
          onClick={() => this.handleModelDelete(cell, row, rowIndex)}
        >
          <i className="fa fa-trash"></i>
        </button>
      </div>
    );
  };

  enabledFormatter = (cell, row) => {
    return cell ? <span>Yes</span> : <span>No</span>;
  };

  handleClick = (e) => {
    this.setState({ isOpen: !this.state?.isOpen });
  };

  handleChange(event) {
    const { name, value } = event.target;
    const { user, errors } = this.state;

    const re = /^[0-9\b]+$/;
    if (name === "contact") {
      if (value === "" || re.test(value)) {
        this.setState({
          user: {
            ...user,
            [name]: value,
          },
          errors: {
            ...errors,
            [name]: "",
          },
        });
      } else {
        this.setState({
          errors: {
            ...errors,
            [name]: "Only numbers are allowed",
          },
        });
      }
    } else {
      this.setState({
        user: {
          ...user,
          [name]: value,
        },
        errors: {
          ...errors,
          [name]: "",
        },
      });
    }
  }

  handlePasswordChange(e) {
    const { name, value } = e.target;
    this.setState({ confirmPassword: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ submitted: true });
    if (this.validateForm()) {
      const { user } = this.state;
      let formData = JSON.stringify(user);

      userService
        .register(formData)
        .then((data) => this.responseShow(data))
        .catch((error) => console.log("Error :" + error));
    }
  }

  responseShow(obj) {
    if (obj.isSuccess) {
      this.handleResetForm();
      this.getData();
    }

    let alertMember = {
      show: true,
      isAnimate: false,
      ariaLabelledby: "",
      title: "Confirmation",
      message: obj.message,
      buttons: [
        {
          label: "Close",
          onClick: this.handleNo,
          cssclass: "btn btn-primary btn-sm ts-buttom",
        },
      ],
    };
    this.setState({ isModelOpen: true, alertMember: alertMember });
  }
  handleResetForm() {
    let user = {
      emailId: "",
      password: "",
      firstName: "",
      lastName: "",
      contact: "",
      createdBy: authenticationService?.currentUserValue?.id,
    };

    this.setState({ user: user, errors: {}, confirmPassword: "" });
  }
  validateForm() {
    let { user, confirmPassword } = this.state;
    let errors = {};
    let isFormValid = true;

    if (!user?.firstName) {
      isFormValid = false;
      errors["firstName"] = "Enter First Name";
    }
    if (!user?.lastName) {
      isFormValid = false;
      errors["lastName"] = "Enter Last Name";
    }
    if (!user?.emailId) {
      isFormValid = false;
      errors["emailId"] = "Enter Email Id";
    } else {
      if (typeof user?.emailId !== "undefined") {
        var pattern = new RegExp(
          /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/
        );
        if (!pattern.test(user?.emailId)) {
          isFormValid = false;
          errors["emailId"] = "Invalid Email";
        }
      }
    }
    if (!user?.contact) {
      isFormValid = false;
      errors["contact"] = "Enter Contact No";
    }
    if (!user?.password) {
      isFormValid = false;
      errors["password"] = "Enter Password";
    } else {
      if (user?.password?.length < 6) {
        isFormValid = false;
        errors["password"] = "Password length is minimum 6";
      }
    }
    if (!confirmPassword) {
      isFormValid = false;
      errors["confirmPassword"] = "Enter Confirm Password";
    } else {
      if (user?.password != confirmPassword) {
        isFormValid = false;
        errors["confirmPassword"] =
          "Password and Confirm Password should be same";
      }
    }

    this.setState({
      errors: errors,
    });

    return isFormValid;
  }

  render() {
    const options = {
      sizePerPage: 5,
      hideSizePerPage: true,
      hidePageListOnlyOnePage: true,
    };

    const columns = [
      // {
      //     dataField: 'id',
      //     text: 'Id'
      // },
      {
        dataField: "emailId",
        text: "Email",
      },
      {
        dataField: "firstName",
        text: "First Name",
      },
      {
        dataField: "lastName",
        text: "Last Name",
      },
      {
        dataField: "contact",
        text: "Contact No",
      },
      {
        dataField: "enabled",
        text: "Active",
        formatter: this.enabledFormatter,
      },
      {
        text: "#Action",
        dataField: "id",
        formatter: this.GetActionFormat,
      },
    ];

    const {
      isOpen,
      confirmPassword,
      user,
      isSubmitted,
      result,
      isModelOpen,
      alertMember,
      isFormValid,
      showUpdateProfile,
    } = this.state;
    const showClass = `page-wrapper chiller-theme ${isOpen ? "toggled" : ""}`;

    return (
      <React.Fragment>
        <div className={showClass}>
          <AdminHeader />
          <AdminSidebar handleClick={this.handleClick} />
          <main className="page-content">
            <div className="container-fluid">
              <h4 className="text-left">User Management</h4>
              <hr className="hr" />
              <h5>Add New User</h5>
              <hr />
              <div className="row">
                <div className="col-sm-12">
                  <div className="box box-primary">
                    <form name="form" onSubmit={this.handleSubmit}>
                      <div className="box-body">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="firstName">First Name</label>
                              <input
                                id="firstName"
                                name="firstName"
                                value={user?.firstName}
                                onChange={this.handleChange}
                                maxLength="20"
                                type="text"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.firstName
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="First Name"
                              />
                              {this.state?.errors?.firstName && (
                                <small className="help-block">
                                  {this.state?.errors?.firstName}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="lastName">Last Name</label>
                              <input
                                id="lastName"
                                name="lastName"
                                value={user?.lastName}
                                onChange={this.handleChange}
                                maxLength="20"
                                type="text"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.lastName
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Last Name"
                              />
                              {this.state?.errors?.lastName && (
                                <small className="help-block">
                                  {this.state?.errors?.lastName}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="emailId">Email</label>
                              <input
                                id="emailId"
                                name="emailId"
                                value={user?.emailId}
                                onChange={this.handleChange}
                                maxLength="30"
                                type="text"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.emailId
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Email"
                              />
                              {this.state?.errors?.emailId && (
                                <small className="help-block">
                                  {this.state?.errors?.emailId}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="contact">Contact No</label>
                              <input
                                id="contact"
                                name="contact"
                                value={user?.contact}
                                onChange={this.handleChange}
                                maxLength="10"
                                type="text"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.contact
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Contact No"
                              />
                              {this.state?.errors?.contact && (
                                <small className="help-block">
                                  {this.state?.errors?.contact}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="password">Password</label>
                              <input
                                id="password"
                                name="password"
                                value={user?.password}
                                onChange={this.handleChange}
                                maxLength="8"
                                type="password"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.password
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Password"
                              />
                              {this.state?.errors?.password && (
                                <small className="help-block">
                                  {this.state?.errors?.password}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label htmlFor="confirmPassword">
                                Confirm Password
                              </label>
                              <input
                                id="confirmPassword"
                                name="confirmPassword"
                                value={confirmPassword}
                                onChange={this.handlePasswordChange}
                                maxLength="8"
                                type="password"
                                className={
                                  "form-control" +
                                  (this.state?.errors?.confirmPassword
                                    ? " invalid"
                                    : "")
                                }
                                placeholder="Confirm Password"
                              />
                              {this.state?.errors?.confirmPassword && (
                                <small className="help-block">
                                  {this.state?.errors?.confirmPassword}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12 text-center">
                            <button type="submit" className="btn btn-primary">
                              SAVE
                            </button>
                            &nbsp;
                            <button
                              type="button"
                              onClick={this.handleResetForm}
                              className="btn btn-primary"
                            >
                              RESET
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <hr />
              <h5>User List</h5>
              <div className="row">
                <div className="col-sm-12">
                  <div className="box">
                    {result.data && result.data.length > 0 ? (
                      <BootstrapTable
                        keyField={"id"}
                        data={result.data}
                        columns={columns}
                        pagination={paginationFactory(options)}
                      />
                    ) : (
                      <NoDataText columns={columns} message="No Data Found" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        {isModelOpen ? <ConfirmationAlert {...alertMember} /> : null}
        {showUpdateProfile ? (
          <UpdateProfile
            updateUser={this.state?.updateUser}
            updateClose={this.updateClose}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
export default UserManagement;
